module.exports = __webpack_public_path__ + "img/mm_logo.e3dbf5a7.png";